import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { jsonRulesEngineCheckResultRenderer } from '@backstage-community/plugin-tech-insights-react';

type CheckResultArg = Parameters<
  typeof jsonRulesEngineCheckResultRenderer.component
>[0];

/**
 * The stock json-rules-engine renderer draws a passing boolean check as
 * `<CheckCircleOutline color="primary" />` — the brand color (blue), which
 * reads as "informational" rather than "passing". Re-point the pass icon at the
 * semantic success token and the fail icon at the error token so the catalog
 * Scorecards card follows the foundation status colors / palette. Inline
 * `var(--c-*)` is safe here (raw CSS, no MUI color math).
 */
function RegaskBooleanCheckIcon({ passed }: { passed: boolean }) {
  return passed ? (
    <CheckCircleOutline style={{ color: 'var(--c-success)' }} />
  ) : (
    <ErrorOutlineIcon style={{ color: 'var(--c-error)' }} />
  );
}

/**
 * Drop-in replacement for {@link jsonRulesEngineCheckResultRenderer}: same
 * `type` and `isFailed`, only the rendered icon is re-tinted. Passed to the
 * TechInsightsClient in {@link ./index.tsx}.
 */
export const regaskBooleanCheckResultRenderer = {
  ...jsonRulesEngineCheckResultRenderer,
  component: (checkResult: CheckResultArg) => (
    <RegaskBooleanCheckIcon passed={Boolean(checkResult.result)} />
  ),
};
